import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "82837fa1-d2b8-4ae8-9d8b-a045a289f73c",
    content: "Answer",
    options: { image: `${config.ASSETS_URL}/04/23/task/task-1-answer-a.svg` },
  },
  {
    id: "6436e033-4477-4d5c-9d38-1ac26555f9aa",
    content: "Answer",
    options: { image: `${config.ASSETS_URL}/04/23/task/task-1-answer-b.svg` },
  },
  {
    id: "3f6a7480-62bf-4d72-a0ac-8985cb2cac9f",
    content: "Answer",
    options: { image: `${config.ASSETS_URL}/04/23/task/task-1-answer-c.svg` },
  },
  {
    id: "e1f702b9-9d77-4d14-8ea3-a13cd858441f",
    content: "Answer",
    options: { image: `${config.ASSETS_URL}/04/23/task/task-1-answer-d.svg` },
  },
];

export const task: Task = {
  id: "5f5834f0-f952-4bc7-81b6-f4a705325556",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6436e033-4477-4d5c-9d38-1ac26555f9aa"],
};
